import React from 'react'
import { Modal, Radio, Button, Checkbox } from 'antd'

const StoryboardDownloadModal = ({
  visible,
  preparing,
  progress,
  statusText,
  quality,
  addToSopAfterDownload,
  generatedFileName,
  isGenerated,
  addingToSop,
  sopAdded,
  canStart,
  onQualityChange,
  onAddToSopAfterDownloadChange,
  onAddToSop,
  onCancel,
  onStart
}) => {
  const isPrimaryBusy = preparing || addingToSop
  const primaryText = preparing
    ? 'Preparing...'
    : addToSopAfterDownload
    ? addingToSop
      ? 'Adding to SOP...'
      : sopAdded
      ? 'Added to SOP Documents'
      : 'Generate, Download & Add to SOP'
    : 'Generate & Download'

  return (
    <Modal
      centered
      maskClosable={!isPrimaryBusy}
      closable={!isPrimaryBusy}
      visible={visible}
      title="Download Storyboard PDF"
      okText={primaryText}
      cancelText={isPrimaryBusy ? null : 'Cancel'}
      onCancel={onCancel}
      onOk={onStart}
      okButtonProps={{
        loading: preparing || addingToSop,
        disabled: isPrimaryBusy || !canStart || (addToSopAfterDownload && sopAdded)
      }}
      cancelButtonProps={{ style: { display: isPrimaryBusy ? 'none' : 'inline-block' } }}
      bodyStyle={{ paddingTop: 18 }}
    >
      {!preparing ? (
        <div style={{ color: '#4b5563', lineHeight: 1.65 }}>
          <div
            style={{
              marginBottom: 10,
              color: '#1f2937',
              fontWeight: 600,
              fontSize: 15
            }}
          >
            Prepare Storyboard Export
          </div>
          <div style={{ marginBottom: 18, fontSize: 13.5 }}>
            Generate a downloadable storyboard PDF with story, scene breakdowns,
            shot images, and dialogue. Choose your preferred output quality below.
          </div>
          <div
            style={{
              marginBottom: 10,
              fontWeight: 600,
              color: '#374151',
              fontSize: 12.5,
              textTransform: 'uppercase',
              letterSpacing: 0.4
            }}
          >
            Export Quality
          </div>
          <Radio.Group
            value={quality}
            onChange={e => onQualityChange(e.target.value)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              padding: '12px 14px',
              border: '1px solid #e6eaf4',
              borderRadius: 10,
              background: '#F4F5FA'
            }}
          >
            <Radio value="high"><strong>High quality</strong> — best visuals, larger file</Radio>
            <Radio value="medium"><strong>Medium quality</strong> — balanced output</Radio>
            <Radio value="low"><strong>Low quality</strong> — fastest and smallest file</Radio>
          </Radio.Group>
          <div
            style={{
              marginTop: 14,
              padding: '12px 14px',
              border: '1px solid #e6eaf4',
              borderRadius: 10,
              background: '#F4F5FA'
            }}
          >
            <Checkbox
              checked={addToSopAfterDownload}
              onChange={e => onAddToSopAfterDownloadChange(e.target.checked)}
            >
              <strong>Also add to SOP Documents</strong>{' '}
              <span style={{ color: '#6b7280' }}>
                after generating this PDF
              </span>
            </Checkbox>
          </div>
          {isGenerated && (
            <div
              style={{
                marginTop: 14,
                paddingTop: 12,
                borderTop: '1px solid #eceff6'
              }}
            >
              <div style={{ fontSize: 12.5, color: '#4b5563', marginBottom: 10 }}>
                Ready: <strong>{generatedFileName}</strong>
              </div>
              {sopAdded && (
                <div style={{ fontSize: 12, color: '#16a34a', marginBottom: 10 }}>
                  Added to SOP Documents
                </div>
              )}
              <Button
                type="default"
                icon={sopAdded ? 'check-circle' : 'folder-add'}
                loading={addingToSop}
                onClick={onAddToSop}
                disabled={addingToSop || sopAdded}
                style={{
                  borderColor: '#5057d5',
                  color: '#5057d5',
                  fontWeight: 600
                }}
              >
                {addingToSop
                  ? 'Adding to SOP Documents...'
                  : sopAdded
                  ? 'Added to SOP Documents'
                  : 'Add to SOP Documents'}
              </Button>
            </div>
          )}
        </div>
      ) : (
        <div>
          <div
            style={{
              marginBottom: 12,
              fontSize: 13,
              color: '#4b5563',
              fontWeight: 500
            }}
          >
            {statusText || 'Preparing download...'}
          </div>
          <div
            style={{
              width: '100%',
              height: 10,
              borderRadius: 999,
              background: '#eef2ff',
              overflow: 'hidden'
            }}
          >
            <div
              style={{
                width: `${progress}%`,
                height: '100%',
                background: '#5057d5',
                transition: 'width 0.3s ease'
              }}
            />
          </div>
          <div
            style={{
              marginTop: 8,
              textAlign: 'right',
              fontSize: 12,
              color: '#6b7280'
            }}
          >
            {progress}%
          </div>
        </div>
      )}
    </Modal>
  )
}

export default StoryboardDownloadModal
